<template>
    <div>
      <carousel :perPage="1" :paginationEnabled="false">

        <slide>
            <div class="padding">
              <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style="font-style:italic">I saw you,</p>
      <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style="font-style:italic">I  saw you,</p>
      <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style="font-style:italic">I know it.</p>
      <p> &nbsp;</p>
            <p> &nbsp;</p>
            <br>
            <p>I was sitting in the window of the cafe near the edgelands, the light was falling and i watched a group of closterers leaving their meeting from the building opposite. They sealed their coats before stepping out from under the archway, for a moment i watched the raindrops illuminated by a flickering street light, they almost looked like they were in slow motion.</p>
            <br>
            <p >Then my view was blocked for an instance as someone walked past right outside the window, something in the movement, in the step, in the the way they buried their hands inside their pockets, something kicked at the back of my mind, just the tiniest trace of a memory, like a bubble growing and bursting. It took me a moment to register, i almost knocked over my coffee as i jumped to the door but by the time i got out on the street i could not see you . . I wanted to call out, to call out a name, but i didn't know what to shout.</p>
            <br>
            <p style="font-style:italic">I left after dark and i heard someone cry out in the distance,</p>
            <br>
            <p>I turned my head but couldn't place where the sound came from. I strained my ears but all the other sounds of the world began to fill my head. I could hear the baristas steaming the machine, the cry of portbirds, the throb of bass from a humdrum . . so many things, around corners, out of sight . . and the harder I listened the bigger the world became.</p>
            <br>
            <p style="font-style:italic">I started picturing the sounds rushing towards me from all across the city, and i listened out for you</p>

            <p> &nbsp;</p>
            <p> &nbsp;</p>
            </div>
        </slide>

      </carousel>

    </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Burst'
    }
  },
  mounted () {
    this.$emit('title-update', this.title)
  }
}
</script>

<style lang="css" scoped>
</style>
